import { loadFromLocalStorage } from './localStorageHelper';

export const hasAccessTokenInLocalStorage = (): boolean => {
    const accessToken = loadFromLocalStorage('token');
    return Boolean(accessToken);
};
